import { IFlowState } from "./types";

export const state: IFlowState = {
  schedules: null,
  subject: null,
  wait: null,
  step: null,
  etl: null,
};
